import { ApiService } from "../..";

export const applyGroupLeaderRole = (query: {
  username?: string;
  id?: string;
  phoneNumber?: string;
}) => {
  return ApiService.baseAction(
    "user/group_leader",
    {
      data: { query },
    },
    "post"
  );
};
